const AUTH_LOCAL_STORAGE_KEY = "UserData";

const getMemberId = () => {
  const auth = getAuth();
  if (auth) {
    return auth["memberid"];
  }
  return;
};

const getLoginId = () => {
  const auth = getAuth();
  if (auth) {
    return auth["loginid"];
  }
  return;
};
const getBindAgent = () => {
  const auth = getAuth();
  if (auth) {
    return auth["bindagent"];
  }
  return;
};
const getDatabaseName = () => {
  const auth = getAuth();
  if (auth) {
    return auth["databasename"];
  }
  return;
};

const getEmail = () => {
  const auth = getAuth();
  if (auth) {
    return auth["email"];
  }
  return;
};

const getIsAgent = () => {
  const auth = getAuth();
  if (auth) {
    return auth["isagent"];
  }
  return;
};

const getTelno = () => {
  const auth = getAuth();
  if (auth) {
    return auth["telno"];
  }
  return;
};

const getPlan = () => {
  const auth = getAuth();
  if (auth) {
    return auth["plancode"];
  }
  return;
};
const getAuth = () => {
  if (!localStorage) {
    return;
  }

  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const auth = JSON.parse(lsValue);
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};

const setAuth = (auth) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE SAVE ERROR", error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE REMOVE ERROR", error);
  }
};

export {
  getAuth,
  setAuth,
  removeAuth,
  getMemberId,
  getLoginId,
  getEmail,
  getIsAgent,
  getTelno,
  getDatabaseName,
  getPlan,
  getBindAgent,
  AUTH_LOCAL_STORAGE_KEY,
};
